import { Controller } from "stimulus"

export default class extends Controller {
  static values = { url: String, newPortOnly: Boolean }

  connect() {
    this.ajax_autocomplete_wrapper(this.urlValue, this.newPortOnlyValue, this.element);
  }

  ajax_autocomplete_wrapper(url, newPortOnlyValue, element) {
    $(element).autocomplete({
      autoFocus: false,
      source: this.ajax_autocomplete(url, newPortOnlyValue),
      minLength: 0,
    });
  }

  ajax_autocomplete(url, newPortOnlyValue) {
    const ret = function(request, response) {
        let searchUrl = url + request.term;
        if (newPortOnlyValue) {
            searchUrl += '?new_port_only=true';
        }
        if (request.term && request.term.match(/\S/g)) {
            $.ajax({
                url: searchUrl,
                dataType: 'json',
                type: 'GET',
                cache: true,
                success: function(data) {
                    response(data);
                },
                error: function(XMLHttpRequest, textStatus, errorThrown) {
                    response(['']);
                }
            });
        }
    }
    return ret;
  }
}
